<template>
  <div> 
    <div
      class="tile is-parent" style="max-width: 500px; margin: auto; margin-top: 50px">
      <article class="tile is-child box" style>
        <div class="content">
          <div id="check" />
          <h2 style="text-align: center; margin-top: 0px">{{ title }}</h2>
          <p style="text-align: left" v-for="text in texts" v-bind:key="'text' + text.str">
            {{ text.str }}
          </p>
        </div>
      </article>
    </div>
  </div>
</template>
<script>
import Input from "@/components/shared/Input";
// import Slider from "@/components/shared/Slider";
// import List from "@/components/shared/List";
import ApplyPage from "@/components/shared/ApplyPage";
import $ from "jquery";
export default {
  name: "Approval",
  components: {
    // Input,
    // Slider,
    // List
  },
  props: {
    texts: Array,
    title: String,
    link: String
  },
  mixins: [ApplyPage],
  data() {
    return {
      initial_message : true,      
    };
  },
  mounted: function () {
    console.log("mounted approval.vue");
    console.log('leadid',this.link)
      var self = this;
    
    for (var i = 0; i < 80; i++) {
      create(i);
    }

    function create(i) {
      var width = Math.random() * 20;
      var height = width * 0.4;
      var colour = "green";

      $('<div class="confetti-' + i + " " + colour + '"></div>')
        .css({
          width: width + "px",
          height: height + "px",
          top: -Math.random() * 20 + "%",
          left: Math.random() * 80 + "%",
          opacity: Math.random() + 0.5,
          transform: "rotate(" + Math.random() * 360 + "deg)",
        })
        .appendTo("#app");
      drop(i);
    }

    function drop(x) {
      $(".confetti-" + x).animate(
        {
          top: "100%",
          left: "+=" + Math.random() * 15 + "%",
        },
        Math.random() * 3000 + 2000,
        function () {
          $(".confetti-" + x).remove();
        }
      );
    }

    setTimeout(function () {
      var animation = lottie.loadAnimation({
        container: document.getElementById("check"), // the dom element that will contain the animation
        renderer: "svg",
        loop: false,
        autoplay: false,
        path: "../animations/check.json", // the path to the animation json
      });
      animation.play();
    }, 1000);

    
    let $heightTest = $("#app-column");
    this.iframe_height =  $heightTest.height() - 120;
    this.iframe_width =  $heightTest.width()- 20;
    if($("body").width() >= 769){
      this.iframe_height =  $("body").height()-250;
    }
  },
  methods :{

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
[class|="confetti"] {
  position: absolute;
}

.green {
  background-color: #3cb968;
}

.level {
  margin-bottom: 10px !important;
}
#check {
  max-width: 20%;
  margin: auto;
  display: block;
}

</style>
<style lang="scss" scoped>

.lds-spinner,
.lds-spinner div,
.lds-spinner div:after {
  box-sizing: border-box;
}
.lds-spinner {
  color: currentColor;
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;

  margin: 0 auto;
  display: block;
}
.lds-spinner div {
  transform-origin: 40px 40px;
  animation: lds-spinner 1.2s linear infinite;
}
.lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 3.2px;
  left: 36.8px;
  width: 6.4px;
  height: 17.6px;
  border-radius: 20%;
  background: currentColor;
}
.lds-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.lds-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.lds-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.lds-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.lds-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.lds-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.lds-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.lds-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.lds-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.lds-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.lds-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.lds-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}
@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

/* Modal container (hidden by default) */
.modal {
    display: none; /* Hidden by default */
    position: fixed; /* Stay in place */
    top: 0;
    left: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
    z-index: 1000; /* Sit on top */
    justify-content: center; /* Center the modal */
    align-items: center; /* Center the modal */
}

/* Modal content */
.modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    text-align: center;
    width: 80%; /* Default width */
    // max-width: 500px; /* Max width */
}

@media (max-width: 47.999em) {
  .modal-content {
    width: 100%; /* Default width */
  }
}

/* Close button */
// .close-button {
//     position: absolute;
//     top: 10px;
//     right: 10px;
//     font-size: 20px;
//     font-weight: bold;
//     cursor: pointer;
//     color: #888;
// }

// .close-button:hover {
//     color: black;
// }
</style>